export enum TimeOffType {
  FullDay = 'FULL_DAY',
  HalfDay = 'HALF_DAY',
  Custom = 'CUSTOM',
}

export type Timeoff = {
  userId?: number;
  note?: string;
  accountId?: number;
  timeOffStart: string;
  timeOffEnd: string;
  deleted?: boolean;
  notifyProjectOwners?: boolean;
  notifyOthers?: number[];
  timeOffDuration: number;
  timeOffType: TimeOffType;
  appliedBy: number;
};

export type TimeoffHistory = Timeoff & {
  timeOffId: string;
  createdAt: number;
  updatedAt: number;
};

export type TimeoffResponse = Timeoff & {
  timeOffId: number;
  notifyProjectOwners?: boolean;
  createdAt?: number;
  updatedAt?: number;
};
